// @ts-check

/**
 * This enumerated type is for classifying mouse buttons: left, middle, and right.
 * @enum {number}
 */
const MouseButton = {
  /**
   * Represents a mouse left button.
   * @type {number}
   * @constant
   */
  LEFT: 0,

  /**
   * Represents a mouse middle button.
   * @type {number}
   * @constant
   */
  MIDDLE: 1,

  /**
   * Represents a mouse right button.
   * @type {number}
   * @constant
   */
  RIGHT: 2,
};

Object.freeze(MouseButton);

export default MouseButton;
